import { useLocation } from "react-router-dom";

function useQuery() {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const params = {};

  for (const [key, value] of queryParams.entries()) {
    params[key] = value;
  }

  return params;
}

export default useQuery;
